import React from "react";
import { Disclosure, Transition } from "@headlessui/react";
import CenterIcon from "./CenterIcon";
import SectionListItem from "./SectionListItem";
import { ReactComponent as SectionCategoryIcon } from "../../assets/Updated-imagery/section_category_icon.svg";
const SectionCategoryListItem = ({ course, sections, category }) => {
    return (
        <Disclosure as="div" className="mb-5">
            {({ open }) => (
                <>
                    <Disclosure.Button className="w-full">
                        <div
                            className={`flex justify-between items-center bg-yellow-100 dark:bg-yellow-900 clr-text-primary px-5 py-3 rounded-md shadow-md smooth cursor-pointer`}
                        >
                            <div className="flex space-x-7 gap-3 items-center">
                                <SectionCategoryIcon className="w-12 h-12" />
                                <span className="font-h2 font-w-bold">{category}</span>
                            </div>
                            <CenterIcon
                                icon="ep:arrow-up-bold"
                                className={`transform transition-transform duration-300 ${
                                    open ? "-rotate-180 text-yellow-600" : "text-slate-600"
                                }`}
                            />
                        </div>
                    </Disclosure.Button>
                    <Transition
                        enter="transition duration-500 ease-out origin-top"
                        enterFrom="transform scale-y-0 opacity-0"
                        enterTo="transform scale-100 opacity-100"
                    >
                        <Disclosure.Panel className="mt-3 px-4">
                            <div className="space-y-5">
                                {sections.map((section, index) => (
                                    <SectionListItem
                                        key={index}
                                        section={section}
                                        course={course}
                                    />
                                ))}
                            </div>
                        </Disclosure.Panel>
                    </Transition>
                </>
            )}
        </Disclosure>
    );
};

export default SectionCategoryListItem;
